export default __webpack_public_path__ + "static/media/shape4.c67d5864.png";